import { createAction, createReducer } from 'deox';
import { filter, propEq } from 'ramda';
import { resetApplication } from './resetApplication';

interface BaseInitialFinanceOffer {
  id: string;
  termLength: number;
  maxCartSize: number;
  minCartSize: number;
  minRate: number;
  maxRate: number;

  paymentProductType: 'SPLITPAY' | 'INSTALLMENTS';
  termInterval: 'BIWEEKLY' | 'MONTHLY';
}

export interface InstallmentsInitialOffer extends BaseInitialFinanceOffer {
  paymentProductType: 'INSTALLMENTS';
  termInterval: 'MONTHLY';
}

export interface SplitPayInitialOffer extends BaseInitialFinanceOffer {
  paymentProductType: 'SPLITPAY';
  termInterval: 'BIWEEKLY';
}

export type InitialFinanceOffer =
  | InstallmentsInitialOffer
  | SplitPayInitialOffer;

export interface InitialFinanceOffersState {
  entities: InitialFinanceOffer[] | null;
}

export const defaultState: InitialFinanceOffersState = {
  entities: null,
};

export const setInitialFinanceOffers = createAction(
  'SET_INITIAL_FINANCE_OFFERS',
  resolve => (initialFinanceOffers: InitialFinanceOffer[]) =>
    resolve({ initialFinanceOffers }),
);

export const InitialFinanceOffersReducer = createReducer(
  defaultState,
  handleAction => [
    handleAction(
      setInitialFinanceOffers,
      (state, { payload: { initialFinanceOffers } }) => ({
        ...state,
        entities: initialFinanceOffers,
      }),
    ),

    handleAction(resetApplication, () => defaultState),
  ],
);
export const selectInitialFinanceOffers = (
  state: MountedState,
): InitialFinanceOffer[] | null => state.initialFinanceOffers.entities;

export interface MountedState {
  initialFinanceOffers: InitialFinanceOffersState;
}

export const selectInitialFinanceOffersByType = (state: MountedState) => {
  const initialOffers = selectInitialFinanceOffers(state);

  const installmentInitialOffers = filter(
    propEq('paymentProductType', 'INSTALLMENTS'),
    initialOffers || [],
  ) as InstallmentsInitialOffer[];

  const splitPayInitialOffers = filter(
    propEq('paymentProductType', 'SPLITPAY'),
    initialOffers || [],
  ) as SplitPayInitialOffer[];

  return {
    installmentInitialOffers,
    splitPayInitialOffers,
  };
};

export default InitialFinanceOffersReducer;
